import React, { useState } from 'react';

import CatalogTab from './components/CatalogTab';
import CohortsTab from './components/CohortsTab';
import ConfigTab from './components/ConfigTab';
import UpcomingTab from './components/UpcomingTab';

type Tab = 'catalog' | 'upcoming' | 'config' | 'cohorts';

const ACTIVE = { color: '#4F79B7', borderBottom: '2px solid #4F79B7' };
const INACTIVE = { color: '#6B7280', borderBottom: '2px solid transparent' };

const ProductUpdates: React.FC = () => {
  const [tab, setTab] = useState<Tab>('upcoming');

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="flex-shrink-0 px-6 pt-5 bg-white border-b">
        <h1 className="mb-4 text-xl font-bold text-gray-900">Product Updates</h1>
        <div className="flex gap-6">
          {(
            [
              { id: 'catalog', label: 'Lanzamientos' },
              { id: 'upcoming', label: 'Próxima edición' },
              { id: 'config', label: 'Configuración' },
              { id: 'cohorts', label: 'Cohorts' },
            ] as { id: Tab; label: string }[]
          ).map(({ id, label }) => (
            <button
              key={id}
              type="button"
              style={{
                paddingBottom: 12,
                fontSize: 14,
                fontWeight: 600,
                background: 'none',
                border: 0,
                cursor: 'pointer',
                transition: 'color 150ms ease, border-bottom-color 150ms ease',
                ...(tab === id ? ACTIVE : INACTIVE),
              }}
              onClick={() => setTab(id)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex-1 overflow-hidden">
        {tab === 'catalog' && <CatalogTab />}
        {tab === 'upcoming' && <UpcomingTab />}
        {tab === 'config' && <ConfigTab />}
        {tab === 'cohorts' && <CohortsTab />}
      </div>
    </div>
  );
};

export default ProductUpdates;
